import React, {useState, useEffect} from "react";
import { useSelector , useDispatch} from 'react-redux'
// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card,Badge, 
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import Select from "react-select";
import {customStyles} from '../../../helpers/mycomps'
import Switch from "react-bootstrap-switch";
import Wal from '../../../assets/img/Whatsapplogo.png'
import CreateVInfo from './CreateVInfon'

const modelyears = [
    {value : 0 , label : '2025'},
     {value : 1 , label : '2024'},
     {value : 2 , label : '2023'},
     {value : 3 , label : '2022'},
     {value : 4 , label : '2021'},
     {value : 5 , label : '2020'},
     {value : 6 , label : '2019'},
     {value : 7 , label : '2018'},
     {value : 8 , label : '2017'},
     {value : 9 , label : '2016'},
     {value : 10 , label : '2015'},
     {value : 11 , label : '2015'}, 
     {value : 12 , label : '2014'}, 
     {value : 13 , label : '2013'},
     {value : 14 , label : '2012'}, 
     {value : 15 , label : '2011'}, 
     {value : 16 , label : '2010'}, 
     {value : 17 , label : '2009'},
     {value : 18 , label : '2008'},
     {value : 19 , label : '2007'},
     {value : 20 , label : '2006'},
     {value : 21 , label : '2005'},
     {value : 22 , label : '2004'},
     {value : 23 , label : '2003'},
     {value : 24 , label : '2002'},
     {value : 25 , label : '2001'},
     {value : 26 , label : '2000'},
     {value : 27 , label : '1999'},
     {value : 28 , label : '1998'},
     {value : 29 , label : '1997'},
     {value : 30 , label : '1996'},
     {value : 31 , label : '1995'},
     {value : 32 , label : '1994'},
     {value : 33 , label : '1993'},
     {value : 34 , label : '1992'},
     {value : 35 , label : '1991'},
     {value : 36 , label : '1990'}, 
     {value : 37 , label : '1989'}, 
     {value : 38 , label : '1988'},
     {value : 39 , label : '1987'},
     {value : 40 , label : '1986'},
     {value : 41 , label : '1985'}, 
     {value : 42 , label : '1984'},
     {value : 43 , label : '1983'}, 
     {value : 44 , label : '1982'}, 
     {value : 45 , label : '1981'}, 
     {value : 46 , label : '1980'}, 
     {value : 47 , label : '1979'}
   ]

function Listing(props) {
   
    const catlist  = useSelector(state => state.featureStore.featureData).map((x, key) => {
        return {
              label :x.categoryName.en  , value : x.categoryCode, 
              labelfr : x.categoryName.fr, labelar : x.categoryName.ar,
              features : x.features, unit : x.unit,
              key: key
            }
          })    
 

    const storarea  = useSelector(state => state.areaStore.areaData).map((x, key) => {
            return {
                  label :x.cityName.en  , value : x.cityCode, 
                  labelfr : x.cityName.fr, labelar : x.cityName.ar,
                  areas : x.area , key :key
                }
              })

    

    const [selarea,setSelarea] = useState({
        label :""  , value : "", 
        labelfr : "", labelar : "",
        areas : "" , key : ""
    })
    
    const [advslist, setAdvslist] = useState([])

    const [arealist , setArealist] = useState([])
    const [selareal,setSelareal] = useState({
        label :""  , value : "", 
        areaCode : "", en : "",
        ar : "" , fr : ""
    })

    const [seldelarea,setSeldelarea] = useState({
      label :""  , value : "", 
      areaCode : "", en : "",
      ar : "" , fr : ""
  })


    const [selfetlist, setSelfetlist] = useState([])              
    const [selcat, setSelcat] = useState("1")      
    const [selpr, setSelpr] = useState({min: "0" , max: ""})    

    const [seldw, setSeldw] = useState(false)
    const [selinsurence, setSelinsurence] = useState(false)
    // search only premium
    const [selpremium, setSelpremium] = useState(false)
    const [fulltext, setFulltext] = useState("-")

    const [showProcessing, setShowProcessing] = useState(false)
    const [brandList, setBrandList] = useState([])
    const [selectedvehicle, setSelectedvehicle] = useState({
        label : "" , value : "", mname :  {en : "", fr : "", ar : ""},
        bid : "" , bname : {en : "", fr : "", ar : ""}, notes : ""
    })

    const [vehicleList, setVehicleList] = useState([])

    const [vlfiltered, setVlfiltered] = useState([])

    const [selectedbrand, setSelectedBrand] = useState({
        bid : "", bname : {en : "", fr :"", ar : ""},
        blogo : ""
    })
    const [vtypeList , setVtypeList] = useState([])
    const [selectedtype, setSelectedtype] = useState({
        categoryCode : "", categoryName : {en : "", fr :"", ar : ""},
        typeCode : "" , typeName : {en : "", fr :"", ar : ""},
        value : "", label : ""
    })

    const [selectedyear, setSelectedyear] = useState({label : "", value : ""})
    const [seltrans, setSeltrans] = useState({label  : "", value : ""})
    const [selfuel, setSelfuel] = useState({label  : "", value : ""})

    const [data, setData] = useState([])

    const [limit, setLimit] = useState({"limit" : 30, "page" : 0 })
    const [records, setRecords] = useState(0)
    const [infom, setInfom] = useState(false)
    const [tluid, setTluid] = useState("")

    const [txtn, setTextn] = useState("0")

    const populatebrands = () => {
        setShowProcessing(true)
          props.API.get(`tenant/getbrands`, { headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            let xdata = {value : "" , label : "Any", blogo  :"", key : "", bid : "", bname : {en : "Any", fr : "", ar : "" }, createDate : "2023-09-28T09:03:26.016Z", createdBy : "Admin" , updateBy : "Admin", udpateDate : "2023-08-27T13:08:21.209Z"}
            let ndata =  res.data.map((r, key) => {
              return {
                  ...r, value : r.bid, label : r.bname.en,
                  blogo : r.blogo, key: key
              }
          })
          //console.log(ndata[0])
            ndata.push(xdata)
            ndata.sort((a, b) => 
              a.label > b.label ? 1 : -1,
            )
            setBrandList(ndata)
           
                            
            }).catch(function (error) {
              setShowProcessing(false)
              if(error.response.status === 401){
                props.swal("Unauthorized, please login again.").then(t => {
                    props.history.push(`/auth/login`)
                })   
              }
            }) 
          
            props.API.get(`getmodelsd`).then((res) => {
               
                let data = res.data.map((g, key) => {

                    return {
                        label : g.mname.en + " " + g.notes, value : g.vid, mname : g.mname,
                        bid : g.bid , bname : g.bname, key: key
                    }
                  })
             
              setVehicleList(data) 
                            
            }).catch(function (error) {
                console.log(error)
                setShowProcessing(false)
                if(error.response.status === 401){
                  props.swal("Unauthorized, please login again.").then(t => {
                      props.history.push(`/auth/login`)
                  })   
                }
            }) 
            props.API.get(`vtypes/${"-"}`).then((res) => {
                let data = res.data.map((x, key) => {
                    return {
                        categoryCode : x.categoryCode, categoryName : x.categoryName,
                        typeCode : x.typeCode , typeName : x.typeName,
                        value : x.typeCode, label : x.typeName.en, key: key
                    }
                })
                
                setVtypeList(data)
                                
              }).catch(function (error) {
                setShowProcessing(false)
                if(error.response.status === 401){
                  props.swal("Unauthorized, please login again.").then(t => {
                      props.history.push(`/auth/login`)
                  })   
                }  
              }) 
              setShowProcessing(false)
      }

    const sndvlist = (filteredlist) => {
      
      let xdata = {value : "" , label : "Any", key : "", bid : "", bname : {en : "Any", fr : "", ar : "" },  mname : {en : "Any", fr : "", ar : "" }}
      filteredlist.push(xdata)
      filteredlist.sort((a, b) => 
              a.label > b.label ? 1 : -1,
            )
      
      setVlfiltered(filteredlist)
    }  

    useEffect(() => {
        populatebrands()
    }, [])  

    useEffect(() => {
      
       try{
      let xy =  catlist?.find(x => x.value === selcat)
      let ndata = xy.features.map(t => {
        return {
          ...t, rangevalueL  : "0", isfibtype: t.fib, fib : false
          
        }
      }) 
      console.log(ndata) 
      setAdvslist(ndata)
    }catch(e){
      console.log("ERUEF")
    } 
      
    }, [selcat])

   const showcatb = () => {
    return (
        catlist.map((x , key)=> {
        
            return (
                <Button size="sm" key={key} onClick={i => {setSelcat(x.value); setSelfetlist(x.features);}}>{x.label}</Button>
            )
        })
    )
   }

   const searches = (t) => {
    t.preventDefault()
    setShowProcessing(true)
   
    let query = `${limit.limit}/${limit.page}/1/1/${selpremium ? "Premium"  : "Featured"}/${selcat}/${selarea.value === "" ? "-" : selarea.value}/${selareal.value === "" ? "-" : selareal.value}/${selectedbrand.bid === "" ? "-" : selectedbrand.bid}
    /${selectedvehicle.value === "" ? "-" : selectedvehicle.value}/${selectedtype.typeCode === "" ? "-" : selectedtype.typeCode}/
    ${selectedyear.label === "" ? "-".trim() : selectedyear.label.trim()}/${selinsurence}/${selpr.min === "" ? "0" : selpr.min}/${selpr.max === "" ? "0" : selpr.max}/${seldw}/
    ${selfuel.value === "" ? "-" : selfuel.value}/${seltrans.value === "" ? "-" : seltrans.value}/-/${seldelarea.value === "" ? "-" : seldelarea.value}/${fulltext}`

    props.API.get(`/gvbcrwt/${query}`).then(res => {
      
      setData(res.data.data)
      setRecords(Number(res.data.countt))
      setShowProcessing(false)
    }).catch(e => {
      setShowProcessing(false)
      if(e.response.status === 401){
        props.swal("Unauthorized, please login again.").then(t => {
            props.history.push(`/auth/login`)
        })   
      }
    })
    
   }

   const fsearches = (t) => {
    t.preventDefault()
    // 1) Refine and remove all features with zero values 
    // 2) Make parameter query string and send it to backed API 
    let nadv = advslist.filter(g => g.rangevalueL !== "0" || g.fib !== false)
    let nadvgt = JSON.stringify(nadv)

    setShowProcessing(true)
    props.API.get(`/gvbcrf/${limit.limit}/${limit.page}/${selcat}/0/1/${nadvgt}`).then(res => {
      setData(res.data.data)
      setShowProcessing(false)
      
    {/**    
      try{
        let xy =  catlist.find(x => x.value === selcat)
        let ndata = xy.features.map(t => {
          return {
            ...t, rangevalueL  : "0"
          }
        })  
        setAdvslist(ndata)
      }catch(e){

      }*/}
    }).catch(e => {
      setShowProcessing(false)
      if(e.response.status === 401){
        props.swal("Unauthorized, please login again.").then(t => {
            props.history.push(`/auth/login`)
        })   
      }
    })
    

   }

   const searchess = (page) => {
   
    setShowProcessing(true)
   
    let query = `${limit.limit}/${limit.page}/1/1/${selpremium ? "Premium"  : "Featured"}/${selcat}/${selarea.value === "" ? "-" : selarea.value}/${selareal.value === "" ? "-" : selareal.value}/${selectedbrand.bid === "" ? "-" : selectedbrand.bid}
    /${selectedvehicle.value === "" ? "-" : selectedvehicle.value}/${selectedtype.typeCode === "" ? "-" : selectedtype.typeCode}/
    ${selectedyear.label === "" ? "-".trim() : selectedyear.label.trim()}/${selinsurence}/${selpr.min === "" ? "0" : selpr.min}/${selpr.max === "" ? "0" : selpr.max}/${seldw}/
    ${selfuel.value === "" ? "-" : selfuel.value}/${seltrans.value === "" ? "-" : seltrans.value}/-/${seldelarea.value === "" ? "-" : seldelarea.value}/${fulltext}`

    props.API.get(`/gvbcrwt/${query}`).then(res => {
      setData(res.data.data)
      setRecords(Number(res.data.countt))
      setShowProcessing(false)
    }).catch(e => {
      setShowProcessing(false)
      if(error.response.status === 401){
        props.swal("Unauthorized, please login again.").then(t => {
            props.history.push(`/auth/login`)
        })   
      }
    })
    
   }
   
   const nextr =() => {
    
    let presentpage = Math.floor(records/ limit.limit)
    
    if(limit.page < presentpage){
      let nextpage = limit.page + 1
      
      setLimit({...limit, page : nextpage})
      searchess(nextpage)
    }
    
   }
   const lastr =() => {
    let presentpage = Math.floor(records/ limit.limit)
    
    setLimit({...limit, page : presentpage})
    searchess(presentpage )
   }
   const prevr =() => {
    if(limit.page >=1){
      setLimit({...limit, page : limit.page -1})
      searchess(limit.page -1)
    }
   
   }
   const firstr =() => {
    setLimit({...limit, page : 0})
    searchess(0)
   }

   const updarea = () => {
    
    let anydata = {areas : [], key : "", label  :"Any" , labelar : "", labelfr : "" , value : ""}
    let anydatan = storarea
    anydatan.push(anydata)
    
    anydatan.sort((a,b) =>
    a.label > b.label ? 1 : -1,)
    return anydatan
   
    }

   const searchbuttons = () => {
    return (
      <span style={{float : "right"}}>
      <i className="fa fa-backward" aria-hidden="true" style={{paddingRight : 20 , cursor : "pointer"}} onClick={g => firstr()}></i>{' '}
      <i className="fa fa-step-backward" aria-hidden="true" style={{paddingRight : 20 , cursor : "pointer"}} onClick={g => prevr()}></i>{' '}
      <label style={{paddingRight : 20, cursor : "pointer"}}>{Number(limit.limit)*Number(limit.page) > records ? records : Number(limit.limit)*Number(limit.page) } / {records}</label>{' '}
      <i className="fa fa-step-forward" aria-hidden="true" style={{paddingRight : 20, cursor : "pointer"}} onClick={g => nextr()}></i>{' '}
      <i className="fa fa-forward" aria-hidden="true" style={{paddingRight : 50, cursor : "pointer"}} onClick={g => lastr()}></i>{' '}
      <i className="fa fa-search fa-2x" aria-hidden="true" style={{float : "right" , cursor : "pointer", marginTop : -25}}onClick = {t => searches(t)}></i>
      </span>
    )
   }

   const showdet = (tluid) => {
    let aa = {x : "aa", tluid : tluid.tluid}
     let bdy = {cid  : "0", deviceid : "Browser", uid : "Admin" , tuid  : tluid.tuid, tluid : tluid.tluid , vtypecode : tluid.vtypeCode , catcode : tluid.categoryCode }
      setInfom(true)  
      setTluid(aa)
      props.API.post(`cdet`, bdy, { headers :{"arixauth" : localStorage.getItem("arixauth")}})
   }

   const ocrv = (g, val) => {
    let newstate = advslist
    if(val.state){
      
      let ffi = newstate.find(h => h.featureCode === g.featureCode).fib
      if(ffi){
        newstate.find(h => h.featureCode === g.featureCode).fib = false
        newstate.find(h => h.featureCode === g.featureCode).rangevalueL = "0"
      }else{
        newstate.find(h => h.featureCode === g.featureCode).fib = !ffi
        newstate.find(h => h.featureCode === g.featureCode).rangevalueL = "1"
      }
     
    } else{
      newstate.find(h => h.featureCode === g.featureCode).rangevalueL = val
    } 
   
    console.log(newstate)
    setAdvslist(newstate)
   }

   const catlistf = ()  => {
     try{
      return (
        advslist.map((g,key) => {
          return (
                  <Row id={key} style={{paddingBottom : 10, marginLeft : 5}}>
                    <Col > <img src={`${g.ficon}`}  width="30px" /> {g.en}</Col>
                    <Col md="2" style={{padding : 2, marginRight : 30}}><Input style={{marginTop : -6}} value={g.rangevalueL} type="text" onChange={v => ocrv(g, v.target.value)}/></Col>
                  </Row>
           
          )
        })
      )
      
    }catch(e){
     
    }
    
   }
   
    return (
        <div className="content">
         
        <CreateVInfo vehicle={tluid} setInfom={setInfom} infom={infom} API={props.API}/>
        {showProcessing && props.Spin}
        <Row>
          <Col>{showcatb()} <span style={{float: "right"}}> <Switch 
                          offColor="primary"
                          offText="Featured"
                          onColor="primary"
                          onText="Premium"
                          onChange = {x => setSelpremium(!selpremium)}
                          value={selpremium}
                        /></span>
          </Col>
          <Col md="2">  <Input type="text" style={{float : "right", marginTop : -7}} placeholder="Text here..." value={fulltext} onChange={e=> {setFulltext(e.target.value);}} /></Col>
          <Col md="2">{searchbuttons()}</Col>
        </Row>
        <Row>
            <Col md="2">
                {/** displaying Category */}
                
                {/** Select Area */}
                <Row><Col md="3"><label style={{marginTop : 10}}>City</label></Col><Col>
                <Select options={updarea()} styles={customStyles} 
                                            value={selarea} 
                                            onChange={e=> {setSelarea(e); 
                           
                                            let data = storarea.find(m => m.value === e.value)
                                      
                                            setArealist(data.areas.map((u,key) => {return {value : u.areaCode, label : u.en, areaCode : u.areaCode, en : u.en, fr : u.fr , ar : u.ar, key: key}}))
                                            setSelareal({value  : "", label : ""})
                                            }}/>
                </Col></Row>
                <Row><Col md="3"><label style={{marginTop : 10}}>Area</label></Col><Col>
                <Select options={arealist} styles={customStyles} 
                                            value={selareal}
                                            onChange={j => setSelareal(j)} 
                                            />
                </Col></Row>
                <Row><Col md="3"><label style={{marginTop : 10}}>Dlvry</label></Col><Col>
                <Select options={arealist} styles={customStyles} 
                                            value={seldelarea}
                                            onChange={j => setSeldelarea(j)} 
                                            />
                </Col></Row>
                {/** Select Brand */}
                <Row><Col md="3"><label style={{marginTop : 10}}>Brand</label></Col><Col>
                <Select options={brandList} styles={customStyles} 
                                            value={{label : selectedbrand.bname.en , value : selectedbrand.bname.bid}} 
                                            onChange={e=> {setSelectedBrand({ bid : e.bid, bname : e.bname, blogo : e.blogo})
                                            sndvlist(vehicleList.filter(m => m.bid === e.bid))
                                            }}/>
                </Col></Row>
                {/** Select Model */}
                  <Row><Col md="3"><label style={{marginTop : 10}}>Model</label></Col><Col>
                <Select options={vlfiltered} styles={customStyles} 
                                            value={selectedvehicle} 
                                            onChange={e=> { setSelectedvehicle(e)}}/>
                </Col></Row>
                 {/** Select Type */}
                 <Row><Col md="3"><label style={{marginTop : 10}}>Type</label></Col><Col>
                <Select options={vtypeList} styles={customStyles} 
                                            value={selectedtype} 
                                            onChange={e=> setSelectedtype(e)}/>
                </Col></Row>
                  {/** Select Year */}
                  <Row><Col md="3"><label style={{marginTop : 10}}>Year</label></Col><Col>
                  <Select options={modelyears} styles={customStyles} 
                                            onChange={e=> {
                                             setSelectedyear(e)
                                             }} value={selectedyear}
                                            />
                </Col></Row>
                {/** Select Insurence Type */}
                   <Row style={{marginTop : 15}}><Col><h6>Insurence</h6></Col></Row>
                   <Row><Col md="6"><label style={{marginTop : 10}}>{selinsurence ? "Full " : "Any"}</label></Col><Col style={{marginTop : 5}}> 
                   <Switch 
                          offColor="primary"
                          offText="Any"
                          onColor="primary"
                          onText="Full"
                          onChange = {x => setSelinsurence(!selinsurence)}
                          value={selinsurence}
                        />
                </Col></Row>
                {/** Select Price Range */}
                <Row style={{marginTop : 15}}><Col><h6>Price Range</h6></Col></Row>
                   <Row><Col md="6"><label style={{marginTop : 10}}>Min:</label></Col>
                   <Col style={{marginTop : 5}}> 
                   <Input type="text" value={selpr.min} onChange={x => setSelpr({...selpr, min : x.target.value})}/>
                </Col></Row>
                <Row><Col md="6"><label style={{marginTop : 10}}>Max:</label></Col>
                   <Col style={{marginTop : 5}}> 
                   <Input type="text" value={selpr.max} onChange={x => setSelpr({...selpr, max : x.target.value})}/>
                </Col></Row>
                {/** Select Only with drivers */}
                <Row style={{marginTop : 15}}><Col><h6>Driver Option</h6></Col></Row>
                   <Row><Col md="6"><label style={{marginTop : 10}}>{seldw ? "Required" : "Any"}</label></Col><Col style={{marginTop : 5}}> 
                   <Switch 
                          offColor="primary"
                          offText="Any"
                          onColor="primary"
                          onText="Drv"
                          onChange = {x => setSeldw(!seldw)}
                          value={seldw}
                        />
                </Col></Row>
                  {/** transmission type */}
                  
                   <Row><Col md="6"><label style={{marginTop : 10}}>Transmission</label></Col>
                   <Col style={{marginTop : 5}}> 
                   <Select options={[{value : 0, label : "Auto" , fr : "Auto", ar : "آلي"}, {value : 1, label : "Manual", fr : "Manuel", ar : "يدوي"}, {value : 2, label : "Hybrid", fr : "Hybride" , ar : "هجين"}]} styles={customStyles} 
                                   onChange={e=> {
                                       setSeltrans(e)
                                     }}
                                  value={{label : seltrans.label , value : seltrans.value}}
                                   />
                </Col></Row>
                <Row><Col md="6"><label style={{marginTop : 10}}>Fuel</label></Col>
                   <Col style={{marginTop : 5}}> 
                   <Select options={[{value : 0, label : "Petrol" , fr : "Essence", ar : "بنزين"}, {value : 2, label : "Diesel", fr : "Diesel", ar : "ديزل"}, {value : 3, label : "Electric", fr : "Électrique" , ar : "هجكهربائين"},{value : 4, label : "Hybrid", fr : "Hybride" , ar : "هجين"}]} styles={customStyles} 
                                   onChange={e=> {
                                       setSelfuel(e)
                                     }}
                                  value={{label : selfuel.label , value : selfuel.value}}
                                   />
                </Col></Row>
            </Col>
            <Col md="7">
                                    
                <Row>
                {
                data.map((x,key) => {
                  return (
                    <Col md="4" key={key}>
                    <Card >
                      <CardHeader><span style={{fontWeight: "bold"}}>{x.bname.en} {" "} {x.mname.en} {" "}{x.notes}</span>  {x.listingStatus ? "Listed" : "Awaiting..."} {' '}<span className="node-text" style={{float :"right" , color: "lightblue"}}>{x.tenant.tname.en}</span></CardHeader>
                      <CardBody>
                        <Row>
                          <Col><img src={`${x.imgmc}`} alt={"na"} /></Col>
                          <Col>
                            <Row>
                              <Col>Year : {x.modelyear.label}</Col>
                            </Row>
                            <Row>
                              <Col>Mileage : {x.approxmiles}</Col>
                            </Row>
                            <Row>
                              <Col>Fuel : {x.fuelname.en}</Col>
                            </Row>
                            <Row>
                              <Col>Trans : {x.trmname.en}</Col>
                            </Row>
                          </Col>
                        </Row>
                     
                      </CardBody>
                      <CardFooter>
                        <Row>
                          <Col ><Button size="sm" >{x.tluid}</Button></Col>
                         
                          <Col><Button size="sm" style={{float :"right"}} onClick={n => showdet(x)} color = "warning">Details</Button></Col>
                          
                        </Row>
                      </CardFooter>
                    </Card>
                   </Col>
                  )
                })
              }
                </Row>
                
            </Col>
            <Col md="3">
              <Card>
              <p style={{marginTop : 10, marginLeft : 5, color : "blue"}}><i>Advance Search</i> <span style={{float : "right", marginRight : 15}}><i className="fa fa-search" aria-hidden="true" style={{float : "right" , cursor : "pointer"}}onClick = {t => fsearches(t)}></i></span></p>
              {
                 
                advslist.sort((a,b) => b.isfibtype - a.isfibtype).map((g,key) => {
                  if(g.isfibtype){
                    return (
                      <Row id={key} style={{paddingBottom : 10, marginLeft : 5}}>
                        <Col > <img src={`${g.ficon}`}  width="30px" /> {g.en}</Col>
                        <Col md="2" style={{padding : 2, marginRight : 50, fontSize : "0.8rem"}}>
                        <Switch  bsSize="mini"
                                 offColor="primary"
                                 offText="No"
                                 onColor="primary"
                                 onText="Yes"
                                 onChange = {x => {ocrv(g, x)}}
                                  defaultValue = {g.fib}         
                               />
                          </Col>
                      </Row>
               
              )
                  }else{
                    return (
                      <Row id={key} style={{paddingBottom : 10, marginLeft : 5}}>
                        <Col > <img src={`${g.ficon}`}  width="30px" /> {g.en}</Col>
                        <Col md="2" style={{padding : 2, marginRight : 30}}>
                        <Input style={{marginTop : -6}}  type="text" onChange={v => ocrv(g, v.target.value)}/>
                       </Col>
                      </Row>
               
              )
                  }
                 
                })
              }
              
              </Card>
            </Col>
        </Row>
        
        
        </div>
    )
}

export default Listing;